/* eslint-disable @typescript-eslint/no-explicit-any */
import getSessionConfNumber from '../../tests/__mocks__/session-confimation';

const getCsrfToken = async (isLocal: boolean) => {
  try {
    if (isLocal) {
      const csrfToken = getSessionConfNumber();
      return { csrfToken: csrfToken.sesionConfirmationNumber };
    }

    const response = await fetch('/rest/model/atg/rest/SessionConfirmationActor/getSessionConfirmationNumber', {
      method: 'POST',
    });
    const data = await response.json();

    return {
      csrfToken: data.sessionConfirmationNumber,
    };
  } catch {
    throw new Error('Could not retrieve csrf token');
  }
};

export default getCsrfToken;
